<template>
    <div class="p-6 bg-indigo-800 min-h-screen flex flex-col justify-center items-center">
        <div class="lg:w-1/4 mx-auto">
            <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
            <div class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
                <div class="px-3 py-4">
                    <div v-if="page === 1">
                        <h1 class="text-center font-bold text-3xl">Register</h1>
                        <div class="flex flex-wrap flex-col">
                            <text-input required v-model="form.first_name" :errors="$page.props.errors.first_name" class="mt-4 mr-2 " label="First name" type="text" autofocus/>
                            <text-input required v-model="form.last_name" :errors="$page.props.errors.last_name" class="mt-4 mr-2" label="Last name" type="text" />
                            <text-input required v-model="form.mobile" prefix="+960" maxlength="7" :errors="$page.props.errors.mobile" class="mt-4 mr-2" label="Local Mobile Number" type="text"/>
                        </div>
                    </div>

                    <div v-if="page === 2">
                        <h1 class="text-center font-bold text-3xl">Verification Step</h1>
                        <div class="flex flex-wrap flex-col mt-5">
                            <div v-if="!otp_url" class="flex content-center flex-col">
                                <p class="text-sm text-gray-600 leading-normal my-4 text-center">
                                    Your mobile number <b>+960 {{ form.mobile }}</b> needs to be verified.
                                </p>
                                <loading-button :loading="sending_otp" class="btn-primary" type="button" @click="sendOTP">
                                    <p class="text-center w-full">Send Verification Token</p>
                                </loading-button>
                            </div>
                            <div v-else>
                                <text-input required v-model="otp_token" autocomplete="one-time-code" class="my-4" label="Enter Token to verify" type="text" />

                                <loading-button :loading="sending_otp" class="btn-primary" type="button" @click="verifyOTP">Verify Now</loading-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="page === 3">
                        <p>Please enter a secure password to use at the login screen.</p>
                        <text-input required v-model="form.password" :errors="$page.props.errors.password" class="mt-4 mr-2" label="Password" type="password" />
                        <text-input required v-model="form.password_confirmation" class="mt-4 mr-2" label="Password Confirmation" type="password" />
                    </div>

                    <div class="mt-4" v-if="page === 1">
                        <loading-button v-if="!form.mobile_token" :disabled="!form.mobile" :loading="sending" class="btn-primary" type="button" @click="nextOPTPage">Continue</loading-button>
                    </div>

                    <div class="mt-4" v-if="page === 3">
                        <loading-button v-if="!form.mobile_token" :disabled="!form.mobile" :loading="sending" class="btn-primary" type="button" @click="submitForm">Register Account</loading-button>
                    </div>

                </div>

                <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 text-center">
                    <a class="hover:underline text-sm text-center" tabindex="-1" :href="route('login')">Already Registered? Sign In</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import LoadingButton from '@/Shared/LoadingButton'
  import Logo from '@/Shared/Logo'
  import TextInput from '@/Shared/TextInput'

  export default {
    components: {
      LoadingButton,
      Logo,
      TextInput
    },
    data() {
      return {
        sending: false,
        sending_otp: false,
        otp_url: false,
        otp_token: null,
        page:1,
        register_url: null,
        form: {
          tin_number: null,
          first_name: null,
          last_name: null,
          mobile: null,
          mobile_token: null,
          email_address: null,
          password: null,
          password_confirmation: null,
        },
      }
    },

    methods: {
      verifyMobileOtp() {
        if(this.form.first_name && this.form.last_name && this.form.mobile) {
          console.log('setting page number')
          this.page = 2
        } else {
          this.page = 1;
          console.log('reverting to page 1')
        }
      },

      sendOTP() {
        console.log('sendOtp')
        this.sending_otp = true;
        this.$http.post(this.route('ajax.registration.otp.request'), {
          mobile: this.form.mobile
        }).then((response) => {
          this.sending_otp = false
          this.otp_url = response.data.url
        })
      },

      verifyOTP() {
        this.$http.post(this.otp_url, {
          token: this.otp_token
        }).then(response => {
          if(response.data.status == 'valid') {
            this.page = 3
            this.register_url = response.data.url
            console.log('this.register_url', this.register_url)
          } else {
            console.log('response failed')
          }
        });
      },

      nextOPTPage() {
        if(this.page === 1) {
          this.verifyMobileOtp();
        }
      },

      submitForm() {
        if(this.page === 3) {
          if(this.form.first_name && this.form.last_name && this.form.mobile && this.form.password && this.register_url) {

            this.$inertia.post(route('ajax.customer.register'), this.form);

          } else {
            alert('oops! validation failed');
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
